<div>
  <div class="authGridContainer authGridContainer--login authGridContainer--fullScreen">
    <a class="authGrid__logo" href="/" aria-label="Link to main page" tabindex="0">
      <img src="./assets/sbk1-logo.svg" alt="SmartHACCP" />
    </a>
    <div class="authGridColumn authGridColumn--callToActionParent">
      <div class="createFreeAccount">
        <span class="createFreeAccount__text" style="font-size: 1.6em; line-height: 30px; display: none"
          >Effizientes HACCP Management. Mit dem SmartHACCP Manager von SBK1.</span
        >
      </div>
    </div>
    <div class="authGridColumn authGridColumn--formParent">
      <div class="formContainer loginForm">
        <h2>Kennwort vergessen?</h2>

        <!-- Success Message -->
        <div *ngIf="showSuccessMessage" class="success-message-container" style="background-color: #e8f5e9; border: 1px solid #4caf50; border-radius: 8px; padding: 24px; margin-bottom: 20px;">
          <div style="text-align: center;">
            <div style="color: #2e7d32; font-size: 16px; line-height: 1.6; margin-bottom: 16px;">
              <p style="margin: 0 0 12px 0; font-weight: 500;">Deine Anfrage wurde an SBK1 erfolgreich verschickt.</p>
              <p style="margin: 0 0 12px 0;">Nach Prüfung werden wir Ihnen einen neuen Aktivierungslink per E-Mail zukommen lassen.</p>
              <p style="margin: 0; font-weight: 500;">Vielen Dank für Ihre Anfrage.</p>
              <p style="margin: 12px 0 0 0; font-weight: 500;">Ihr SBK1 Team</p>
            </div>
            <button 
              mat-raised-button 
              color="primary" 
              (click)="gotoLogin()"
              style="margin-top: 16px;">
              Zurück zur Anmeldung
            </button>
          </div>
        </div>

        <!-- Form (hidden when success message is shown) -->
        <form *ngIf="!showSuccessMessage" (ngSubmit)="forgotPwd()" [formGroup]="loginForm" novalidate>
          <div class="login-error" [hidden]="!error || isLoading">E-Mail oder Kennwort ist ungültig.</div>
          <br />
          <div class="login-fields" fxLayout="column">
            <mat-form-field [hideRequiredMarker]="true">
              <input
                type="text"
                matInput
                formControlName="email"
                autocomplete="email"
                [placeholder]="'E-Mail'"
                required />
              <mat-error *ngIf="loginForm.controls['email']?.invalid && loginForm.controls['email']?.touched">
                <span>E-Mail muss angegeben werden</span>
              </mat-error>
            </mat-form-field>
            <br />
            <button
              class="btnLogin"
              mat-focus-indicator
              mat-raised-button
              color="primary"
              type="submit"
              [disabled]="loginForm.invalid || isLoading">
              <span *ngIf="!isLoading">Kennwort zurücksetzen</span>
              <span *ngIf="isLoading">Wird gesendet...</span>
            </button>

            <br />
            <br />
            <button mat-flat-button style="padding: 0px" (click)="gotoLogin()">Zurück zur Anmeldung</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
